/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/funds_out'
export default icon
